import { createElement, useState } from 'react';
import { Modal, Pressable, Text, View } from 'react-native';
import { C } from './theme';
import { TimeModal, type RelogioProps } from './TimeWheel';
import { t } from '../lib/i18n';

const p2 = (n: number) => String(n).padStart(2, '0');
type Props = { mode: 'date' | 'time'; value: Date; onPick: (d: Date) => void; onClose: () => void; cor: string };

/** Navegador: hora com a rolagem própria (e "Relógio"/"Digitar"); data com o seletor do navegador. */
export function PickerModal(p: Props) {
  if (p.mode === 'time') return <TimeModal value={p.value} onPick={p.onPick} onClose={p.onClose} cor={p.cor} Relogio={Relogio} />;
  return <DataModal {...p} />;
}

/** "Relógio" no navegador: o campo de hora do próprio navegador. */
function Relogio({ value, onChange }: RelogioProps) {
  return createElement('input', {
    type: 'time', step: 60, defaultValue: `${p2(value.getHours())}:${p2(value.getMinutes())}`,
    onChange: (e: any) => { const [h, mi] = String(e.target.value).split(':').map(Number); if (!isNaN(h) && !isNaN(mi)) { const d = new Date(value); d.setHours(h, mi, 0, 0); onChange(d); } },
    style: { fontSize: 22, padding: 12, borderRadius: 12, border: 'none', background: C.card2, color: C.text, colorScheme: 'dark', fontFamily: 'inherit' },
  });
}

function DataModal({ mode, value, onPick, onClose, cor }: Props) {
  const ini = mode === 'date' ? `${value.getFullYear()}-${p2(value.getMonth() + 1)}-${p2(value.getDate())}` : `${p2(value.getHours())}:${p2(value.getMinutes())}`;
  const [v, setV] = useState(ini);
  function ok() {
    const d = new Date(value);
    if (mode === 'date') { const [y, m, dd] = v.split('-').map(Number); if (y) d.setFullYear(y, m - 1, dd); }
    else { const [h, mi] = v.split(':').map(Number); if (!isNaN(h)) d.setHours(h, mi, 0, 0); }
    onPick(d); onClose();
  }
  return (
    <Modal transparent animationType="fade" onRequestClose={onClose}>
      <Pressable onPress={onClose} style={{ flex: 1, backgroundColor: C.overlay, justifyContent: 'center', padding: 24 }}>
        <Pressable style={{ backgroundColor: C.card, borderRadius: 20, padding: 20, gap: 16 }}>
          <Text style={{ color: C.text, fontWeight: '700', fontSize: 16 }}>{mode === 'date' ? t('Escolher data') : t('Escolher horário')}</Text>
          {createElement('input', { type: mode, value: v, onChange: (e: any) => setV(e.target.value), step: mode === 'time' ? 60 : undefined,
            style: { fontSize: 22, padding: 12, borderRadius: 12, border: 'none', background: C.card2, color: C.text, colorScheme: 'dark', fontFamily: 'inherit' } })}
          <View style={{ flexDirection: 'row', justifyContent: 'flex-end', gap: 20 }}>
            <Pressable onPress={onClose}><Text style={{ color: C.sub, fontSize: 16 }}>{t('Cancelar')}</Text></Pressable>
            <Pressable onPress={ok}><Text style={{ color: cor, fontSize: 16, fontWeight: '700' }}>{t('OK')}</Text></Pressable>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
}
